export const STATUSES = {
  init: {
    name: "Редактируется",
    color: "blue-grey lighten-2",
    icon: "mdi-pencil"
  },

  wait: {
    name: "На утверждении",
    color: "orange lighten-2",
    icon: "mdi-clock-alert"
  },

  accept: {
    name: "Утверждена",
    color: "green",
    icon: "mdi-check"
  },

  reject: {
    name: "Отклонена",
    color: "red darken-4",
    icon: "mdi-window-close"
  },

  new: {
    name: "Не назначена",
    color: "blue-grey lighten-2",
    icon: "mdi-minus"
  }
};

export function getStatusName(id) {
  return (STATUSES[id] || { name: "Н/Д" }).name;
}

export function getStatusColor(id) {
  return (STATUSES[id] || { color: "gray" }).color;
}

export function getStatusIcon(id) {
  return (STATUSES[id] || { icon: "mdi-minus" }).icon;
}
